module.exports = __webpack_public_path__ + "img/zxbg.e5bb377.e5bb3772.jpg";